import { APP_STATUS } from "./constants"

import { DataTransfer } from "./services"


class Switcher {
  select: HTMLSelectElement | null
  button: HTMLButtonElement | null
  form: HTMLFormElement | null
  canSubmit: boolean
  appStatus: string
  price: {
    current: string | undefined,
    old?: string | undefined
  }
  priceBox: HTMLElement | null
  miniBasket: HTMLDivElement | null
  elem: HTMLElement | null
  dataTransfer
  formData

  constructor(elem:HTMLElement) {
    this.elem = elem
    this.miniBasket = document.querySelector('.mini-basket')
    this.button = elem.querySelector('.js-size-button')
    this.select = elem.querySelector('.js-size-select')
    this.price = {
      current: this.select?.selectedOptions[0].dataset.price,
      old: this.select?.selectedOptions[0].dataset['price-old'],
    }
    this.priceBox = elem.parentNode!.querySelector(`div[data-select-name=${this.select?.getAttribute('name')}]`)
    this.canSubmit = true
    this.form = elem.querySelector('form')
    this.dataTransfer = new DataTransfer()
    this.appStatus = APP_STATUS.ready
    this.formData = new FormData()
  }

  setup() {
    this.render()

    this.button?.addEventListener('click', (event) => {
      event.preventDefault()

      this.transferData()
    })

    this.select?.addEventListener('change', (event) => {
      const select = event.target

      if(select instanceof HTMLSelectElement) {
        this.render()
      }
    })
  }

  private render = () => {
    if(this.select?.options && this.select?.options.length <= 1) {
      this.select.setAttribute('disabled', 'disabled')
      this.select.style.display = 'none'
    }

    this.price = {
      current: this.select?.selectedOptions[0].dataset.price,
      old: this.select?.selectedOptions[0].dataset.priceOld,
    }

    const optionName = this.select?.selectedOptions[0].getAttribute('name');
    const optionValue = this.select?.selectedOptions[0].value;

    if(!!optionName && !!optionValue) {
      this.formData.append(optionName, optionValue)
    } else {
      console.log('Невозможно сформировать данные для запроса. Data: name|value: ', optionName, optionValue)
    }

    if(!!this.priceBox) {
      this.priceBox.innerHTML = (this.price.old !== undefined)
        ? `<i>${this.price.old}</i><span>${this.price.current}</span>`
        : this.priceBox!.innerHTML = `<span>${this.price.current}</span>`
    }
  }


  private setButtonText = (status:string) => {
    const textMap = {
      ready: '<i class="icon-basket-add"></i>Купить',
      loading: `<span class="spinner-border spinner-border-sm text-light" role="status">
                  <span class="sr-only">Добавляем...</span>
                </span>`,
      done: 'Добавлено'
    }

    this.button!.innerHTML = textMap[status as keyof typeof textMap]
  }

  private transferData = async () => {
    this.appStatus = APP_STATUS.loading
    this.setButtonText(this.appStatus)

    const res = await this.dataTransfer.sendData(this.formData)
    if(this.miniBasket)
      this.miniBasket.innerHTML = res || ''

    this.setButtonText('done')

    setTimeout(() => {
      this.appStatus = APP_STATUS.ready
      this.setButtonText(this.appStatus)
    }, 3000)
  }
}

export {
  Switcher,
}